import { Feature, LicenceDetailsState } from '@urbanx/agx.agencies.client';
import { StaffRole } from '@urbanx/agx.auth.client';
import { MenuTitles, Pages } from 'constants/menu';

export interface SideMenu {
  title: MenuTitles;
  includeOnlyInState: LicenceDetailsState[];
  pageLink?: Pages;
  requiredRoles?: StaffRole[];
  requiredFeature?: Feature;
  isHidden?: boolean;
  badge?: string;
}

export interface AgxToastState {
  open: boolean;
  color: 'success' | 'info' | 'error';
  message: string;
  duration?: number;
}

export enum NotificationState {
  NotSent,
  Sent,
  Sending,
}
